module.exports = __webpack_public_path__ + "img/header_right.2381bf73.jpg";